import { useMemo } from "react";
import {
  crudRoutes,
  expeditionRoutes,
  externalRouter,
  generalRoutes,
} from "./routesConstants";
import userRoles from "../constants/userRoles";
import type { SvgIconType } from "../helpers/SvgIcon";

interface DashboardCategories {
  title: string;
  icon?: SvgIconType;
  subtitle?: string;
  subtitleValue?: string;
  categories: {
    id: string;
    title: string;
    icon?: SvgIconType;
    path: string;
    openInNewTab?: boolean;
    subtitle?: string;
    value?: string | number;
    isIncreasing?: boolean;
  }[];
  navigationLinks?: {
    link: string;
    label: string;
  }[];
}

function useAppMenuRoutes() {
  const transportRoutes = useMemo<DashboardCategories["categories"]>(
    () => [
      {
        id: userRoles.PREVIEW_USERS,
        title: "Expeditii active",
        icon: "TRANSPORT",
        path: `/`,
      },
      {
        id: userRoles.CREATE_USER,
        title: "Plasare comanda",
        icon: "ADD",
        path: `/${generalRoutes.createAwb}`,
      },
      {
        id: userRoles.CREATE_USER,
        title: "Formeaza BIN",
        icon: "CREATE_BIN",
        path: `/${generalRoutes.createBin}`,
      },
      {
        id: userRoles.CREATE_USER,
        title: "Vezi istoric colet",
        icon: "HISTORY",
        path: externalRouter.translogTracking,
        openInNewTab: true,
      },
    ],
    [],
  );

  const clientWorkingPoints = useMemo<DashboardCategories["categories"]>(
    () => [
      {
        id: userRoles.SCHEDULE_WORKING_POINTS,
        title: "Puncte de lucru",
        icon: "LOCATION",
        path: `/${expeditionRoutes.clientWorkingPoints}`,
      },
      {
        id: userRoles.WORKING_POINTS_ORGANIZE,
        title: "Creeaza punct de lucru",
        icon: "ADD_LOCATION",
        path: `/${expeditionRoutes.clientWorkingPoints}/${crudRoutes.create}`,
      },
      {
        id: userRoles.UNDELIVERED_AWB,
        title: "Comenzi nefinalizate",
        icon: "PENDING_ORDERS",
        path: `/${expeditionRoutes.undeliveredAwb}`,
      },
      {
        id: userRoles.UNDELIVERED_BINS,
        title: "Binuri nefinalizate",
        icon: "PENDING_BINS",
        path: `/${expeditionRoutes.undeliveredBins}`,
      },
      {
        id: userRoles.DELIVERED_AWB_HISTORY,
        title: "Istoric colete livrate",
        icon: "VALIDATE",
        path: `/${expeditionRoutes.deliveredAwbHistory}`,
      },
      {
        id: userRoles.DELIVERY_SHEETS,
        title: "Borderouri de livrare",
        icon: "DOCUMENTS",
        path: `/${expeditionRoutes.deliverySheets}`,
      },
    ],
    [],
  );

  const categories: DashboardCategories[] = useMemo(() => {
    const menuCategories: DashboardCategories[] = [
      {
        title: "Comenzi",
        icon: "TRANSPORT",
        categories: transportRoutes,
      },
      {
        title: "Clienti",
        icon: "CLIENTS",
        categories: clientWorkingPoints,
      },
    ];
    return menuCategories.filter((category) => category.categories.length > 0);
  }, [transportRoutes, clientWorkingPoints]);

  return categories;
}

export default useAppMenuRoutes;
